import {
  ExtraWorkedTimeRequestStatus,
  ExtraWorkedTimeType,
  type GetExtraWorkedTimeRequestsResponse,
} from "@clipboard-health/contract-backend-main";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { type UseQueryResult } from "@tanstack/react-query";

import { useGetExtraWorkedTimeRequestsByShift } from "./useGetExtraWorkedTimeRequestsByShift";

export function useGetPendingFullShiftMissedPunchRequest(
  shiftId: string,
  options: UseGetQueryOptions<GetExtraWorkedTimeRequestsResponse> = {}
): UseQueryResult<GetExtraWorkedTimeRequestsResponse> {
  return useGetExtraWorkedTimeRequestsByShift(
    shiftId,
    { status: ExtraWorkedTimeRequestStatus.PENDING, type: ExtraWorkedTimeType.FULL_SHIFT },
    options
  );
}
